module.exports = __webpack_public_path__ + "static/Logo-58c11b010f7db01bbdb399c716cdf78b.png";